<template>
  <div :class="classList">
    <el-tag
        :class="`severity-level-${severityLevel}`"
        class="button2 capitalize-first-letter"
        size="small"
    >
      {{ severityLevel }}
    </el-tag>
  </div>
</template>
<script>

export default {
  name: "SeverityTag",
  props: {
    severityLevel: {type: String, default: "LOW"},
    classList: {type: String}
  }
};
</script>

<style scoped>
@import "assets/styles/_variables.css";

>>> .button2 {
  width: 70px;
  display: flex;
  justify-content: center;
}

.severity-level-LOW {
  background: #FDF6EC;
  color: #654B23;
  border: 0.5px solid #EDCB98;
}

.severity-level-MEDIUM {
  background: #FAECD8;
  color: #654B23;
  border: 0.5px solid #EDCB98;
}

.severity-level-HIGH {
  background: #FEF0F0;
  color: #BF3951;
  border: 0.5px solid #F5B0B0;
}

.severity-level-CRITICAL {
  background: #FDE2E2;
  color: #732231;
  border: 0.5px solid #F5B0B0;
}

</style>



// WEBPACK FOOTER //
// src/components/button/SeverityTag.vue